module.exports = __webpack_public_path__ + "img/Sad_1.f1fb416c.png";